// extracted by mini-css-extract-plugin
module.exports = {"switch":"style_switch__pc5op","slider":"style_slider____smF","round":"style_round__qJPI5"};